<template>
  <button @click="$emit('input', !value)" :disabled="!configurable">
    <span class="icon" :class="value ? 'locked' : 'unlocked'" v-tooltip="computedTooltip"></span>
  </button>
</template>

<script lang="ts">
  import Vue from "vue";

  export default Vue.extend({
    props: {
      value: {
        type: Boolean,
        default: false
      },
      configurable: {
        type: Boolean,
        default: false
      },
      tooltip: {
        type: String,
        default: null
      }
    },
    data: function () {
      return {};
    },
    computed: {
      computedTooltip(): string {
        if (this.tooltip) {
          return this.tooltip;
        } else if (this.configurable) {
          return "Locked properties will not be editable wherever the template is added.";
        } else {
          if (this.value) {
            return "Property locked by template.";
          } else {
            return "Property unlocked by template.";
          }
        }
      }
    }
  });
</script>